export const GET_DOCUMENTS_REQUEST = 'GET_DOCUMENTS_REQUEST';
export const GET_DOCUMENTS_SUCCESS = 'GET_DOCUMENTS_SUCCESS';
export const GET_DOCUMENTS_FAILURE = 'GET_DOCUMENTS_FAILURE';

export const GET_PDF_REQUEST = 'GET_PDF_REQUEST';
export const GET_PDF_SUCCESS = 'GET_PDF_SUCCESS';
export const GET_PDF_FAILURE = 'GET_PDF_FAILURE';